(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mo-offer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',async(event)=>{
  const copy=event.target.closest('[data-mo-copy]');
  if(copy){
    const label=copy.querySelector('.mo-code__label');
    try{await navigator.clipboard.writeText(copy.dataset.moCopy);label.textContent=copy.dataset.moSuccess;}
    catch{label.textContent=copy.dataset.moFallback;const range=document.createRange();range.selectNodeContents(copy.firstElementChild);const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range);}
  }
  const pause=event.target.closest('[data-mo-pause]');
  if(pause){const strip=pause.closest('[data-mo-motion]');const paused=strip.dataset.paused!=='true';strip.dataset.paused=String(paused);pause.setAttribute('aria-pressed',String(paused));pause.textContent=paused?pause.dataset.moPaused:pause.dataset.moPlaying;}
});
  } catch(e) { console.error(e); }
})();

})();
